import ObjectListStore from './ObjectList';
import { observable } from 'mobx';
import { API_REQUEST_ERROR, API_REQUEST_SUCCEEDED, API_REQUESTING } from './api';

class DspEventStore extends ObjectListStore {
  // no-dd-sa:javascript-best-practices/no-unreachable
  DEFAULT = {
    baseUrl: '/dsp-events',
    fields: [
      { name: 'actual_end_ts', label: 'Created On' },
      { name: 'type', label: 'Event Type' },
      { name: 'assignment_label', label: 'Assignment Label' },
      { name: 'shipment_count', label: 'No. of Shipments' },
      { name: 'notes', label: 'Notes' },
      { name: 'amount', label: 'Amount' },
      { name: 'driver_name', label: 'Driver' },
      { name: 'row_detail', label: '' },
    ],
    filters: {
      page: 1,
      size: 20,
      order_by: 'created_date',
      desc: true,
    },
    details: [
      { label: 'Region', name: 'region_code', styles: { padding: '20px 10px', flexGrow: 0, width: '50px' } },
      { label: 'Assignment', name: 'assignment_id', styles: { padding: '20px 10px', flexShrink: 0 } },
      { label: 'Delivery Date', name: 'delivery_date', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '105px' } },
      { label: 'Start Time', name: 'start_delivery_ts', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '120px' } },
      { label: 'End Time', name: 'end_delivery_ts', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '120px' } },
      { label: 'Route Split', name: 'route_split', styles: { padding: '20px 10px', flex: 0, minWidth: '65px' } },
      { label: 'Total Small', name: 'total_non_perishable', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '125px' } },
      { label: 'Total Large', name: 'total_perishable', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '100px' } },
      { label: 'Total Est Miles', name: 'travel_distance', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '85px' } },
      { label: 'Total Est Time', name: 'working_hours', styles: { padding: '20px 10px', flexShrink: 0, minWidth: '85px' } },
    ],
    listDetails: [
      { label: 'Driver', name: 'driver_id', styles: { padding: '10px', flex: 0 } },
      { label: 'Driver Name', name: 'driver_name', styles: { padding: '10px', flexShrink: 0 } },
      { label: 'Assignment IDs', name: 'assignment_ids', styles: { padding: '10px', flexShrink: 0 } },
      { label: 'Total Records', name: 'count', styles: { padding: '10px', flexShrink: 0 } },
      { label: 'Total Amount', name: 'total_amount', styles: { padding: '10px', flexShrink: 0 } },
    ],
    result: {
      count: 0,
      items: [],
      total_pages: 0,
    },
    listField: 'dspTransactions',
    idField: 'id',
    processResult: (data, store) => {
      const dspSurchargeTransactions = data.dspTransactions.filter((d) => ['OUTVOICE - SURCHARGE'].includes(d.type));

      dspSurchargeTransactions.forEach((transaction) => {
        if (transaction.delivery_surcharge_payouts && transaction.delivery_surcharge_payouts.length > 0) {
          const driverGroups = {};

          transaction.delivery_surcharge_payouts.forEach((payout) => {
            const driverId = payout.driver_id;
            if (!driverGroups[driverId]) {
              driverGroups[driverId] = {
                driver_id: driverId,
                driver_name: payout.driver_name,
                total_amount: 0,
                assignment_ids: new Set(),
                count: 0,
              };
            }

            driverGroups[driverId].total_amount += payout.amount;
            if (payout.assignment_id) {
              driverGroups[driverId].assignment_ids.add(payout.assignment_id);
            }
            driverGroups[driverId].count += 1;
          });

          transaction.driverGroups = Object.values(driverGroups).map((group) => ({
            ...group,
            assignment_ids: Array.from(group.assignment_ids).join(', '),
          }));
        } else {
          transaction.driverGroups = [];
        }
      });

      const nonSurchargeTransactions = data.dspTransactions.filter((d) => !['OUTVOICE - SURCHARGE'].includes(d.type));
      data.dspTransactions = [...nonSurchargeTransactions, ...dspSurchargeTransactions];
      const total = data.count || data.total;

      store.result = {
        items: data.dspTransactions,
        count: total || data.dspTransactions.length,
        total_pages: total && this.filters.size ? Math.ceil(total / this.filters.size) : 1,
      };
    },
  };

  // no-dd-sa:javascript-best-practices/no-unreachable
  @observable addEventStatus = {};
  // no-dd-sa:javascript-best-practices/no-unreachable
  @observable transactions = [];
  // no-dd-sa:javascript-best-practices/no-unreachable
  @observable loadingTransactions = false;

  constructor(api) {
    super(api);
    this.api = api;
    this.setData(this.DEFAULT);
    this.paymentDetails = null;
  }

  addEvent(event) {
    this.addEventStatus.status = API_REQUESTING;
    this.api.post(`/dsp-events`, event).then((response) => {
      if (response.status === 200) {
        this.addEventStatus.status = API_REQUEST_SUCCEEDED;
        this.search();
      } else {
        this.addEventStatus = { status: API_REQUEST_ERROR, message: response.data.errors ? response.data.errors.join(', ') : response.data.message };
      }
    });
  }

  listEvents(contractorId, from, to) {
    this.loadingTransactions = true;
    this.api.get(`/dsp-events/list`, { contractor_id: contractorId, from, to }).then((res) => {
      if (res.ok) {
        this.transactions = res.data;
      } else {
        this.transactions = [];
      }
      this.loadingTransactions = false;
    });
  }

  resetEvents() {
    this.transactions = [];
  }

  resetStatuses() {
    this.addEventStatus = {};
  }
}

export default DspEventStore;
